import {
  BookingScheduleDto,
  BookingScheduleInterface
} from "../../../features/Booking-Form/typings/booking.types";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { SCHEDULE_QUERY_STALE_TIME_MS } from "./schedule-query-cache.constants";

type Params = {
  bookingScheduleDto: BookingScheduleDto;
  hasVehicleLicense: boolean;
};

export function useRemoteFetchVehicleSchedule(params: Params) {
  const { bookingScheduleDto, hasVehicleLicense } = params;
  const { userIds, startDate, endDate } = bookingScheduleDto;

  return useRemoteQuery<BookingScheduleInterface[]>({
    queryKey: ["vehicleSchedule", bookingScheduleDto],
    url: "/booking-schedule/vehicle",
    params: { userIds, startDate, endDate },
    enabled: !!startDate && !!endDate && hasVehicleLicense,
    staleTime: SCHEDULE_QUERY_STALE_TIME_MS
  });
}
